export default "__VITE_PUBLIC_ASSET__c8dee7c1__"